import axios from "axios";
import qs from "qs";
import router from "../../router";
import utile from "../public/utile.js"; //弹窗

// axios.defaults.baseURL = 'http://192.168.31.146:89/api/'; //本地运行
// axios.defaults.baseURL = 'http://ksds.sddns.com.cn/index.php/api/'; //测试环境
axios.defaults.baseURL = "https://report.kaoshifabao.fun/index.php/api/"; //线上运行

axios.interceptors.request.use(
  (config) => {
    config.headers["token"] = localStorage.getItem("token") || "";
    config.headers["Content-Type"] =
      "application/x-www-form-urlencoded;charset=UTF-8";
    // config.headers['X-Requested-With'] = 'XMLHttpRequest'
    return config;
  },
  (response) => {
    // 如果返回的状态码为1，说明接口请求成功，可以正常拿到数据
    // 否则的话抛出错误
    if (response.status === 1) {
      return Promise.resolve(response);
    } else {
      return Promise.reject(response);
    }
  },
);

const POST = function (url, parametero, parametert, parameterh, el) {
  var data = typeof parametero === "function" ? "" : parametero;
  var callback = typeof parametero === "function" ? parametero : parametert;
  var errorback = "";
  if (typeof parameterh === "function") {
    errorback = parameterh;
  } else if (
    typeof parametero === "function" &&
    typeof parametert === "function"
  ) {
    errorback = parametert;
  }
  axios
    .post(url, qs.stringify(data))
    .then(function (res) {
      if (res.data.code == 0) {
        console.log(el);
        if (el && el == 1) {
          utile.prompt("error", res.data.msg, function () {}, 1);
        } else {
          utile.prompt("error", res.data.msg);
        }
      } else if (res.data.code == 1) {
        callback(res.data);
      } else if (res.data.code == 2) {
        exitfun(res.data);
      }
    })
    .catch(function (res) {
      utile.prompt("error", "操作失败！");
    });
};

//文件流
const FILE = function (url, data, callback) {
  axios
    .post(url, data, {
      headers: {
        "Content-Type":
          "multipart/form-data; boundary=----WebKitFormBoundaryuGALfy504nLAx7m2",
      },
    })
    .then(function (res) {
      callback(res.data);
    });
};

// 退出方法
const exitfun = function () {
  localStorage.removeItem("token");
  localStorage.removeItem("userInfor");
  router.push({
    name: "Common",
  });
};

export default {
  POST,
  FILE,
};
